import Session from "@lib/session";
import epicPassValidateDate from "./epic_pass_validate_date";
import reprice from "@services/reprice";

export default async function addEpicPass({ id }: { id: string }): Promise<boolean> {
  // Add pass to booking object.
  const booking = Session.getBooking();
  booking.otherInfo.epicPassId = id;
  Session.updateBooking({ otherInfo: booking.otherInfo });

  const legs = Session.getBooking().activeLegs();

  // For each leg, validate the epic pass against the pickup date. Add the epicPassValidated flag if valid.
  for (const [index, leg] of legs.entries()) {
    const validationChanged = await validateEpicPassOnLeg(index);
    if (validationChanged) await reprice(index, false);
  }
}

// Returns boolean indicating whether the epic pass validation status changed.
export async function validateEpicPassOnLeg(legIndex: number): Promise<boolean> {
  const epicPassId = Session.getBooking().otherInfo?.epicPassId;
  if (!epicPassId) return false;

  const leg = Session.getLeg(legIndex),
    pickupDate =
      leg.service?.selectedTime?.pickupTime || leg.requestedPickupTime || leg.flight?.flightTime;
  if (!pickupDate) return false;
  const valid = await epicPassValidateDate({ id: epicPassId, pickupDate });

  if (valid && !leg.epicPassValidated) {
    leg.epicPassValidated = true;
    Session.setLeg(legIndex, leg);
    return true;
  } else if (!valid && leg.epicPassValidated) {
    leg.epicPassValidated = false;
    Session.setLeg(legIndex, leg);
    return true;
  }
  return false;
}
